var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10941_90244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8096 14.3457L9.72737 2.25977C9.18516 1.33008 7.81686 1.33008 7.271 2.25977L0.192092 14.3457C-0.352772 15.2721 0.325867 16.4375 1.41795 16.4375H15.5824C16.6701 16.4375 17.3508 15.2754 16.8096 14.3457ZM7.70197 6.07812C7.70197 5.63818 8.05891 5.28125 8.49885 5.28125C8.93879 5.28125 9.29572 5.63984 9.29572 6.07812V10.3281C9.29572 10.7681 8.93879 11.125 8.52873 11.125C8.11867 11.125 7.70197 10.7697 7.70197 10.3281V6.07812ZM8.49885 14.3125C7.92244 14.3125 7.45494 13.845 7.45494 13.2686C7.45494 12.6922 7.92211 12.2247 8.49885 12.2247C9.07559 12.2247 9.54276 12.6922 9.54276 13.2686C9.54143 13.8443 9.07658 14.3125 8.49885 14.3125Z",
    fill: "#D48806"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10941_90244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.a7c7d7410dfcdfd449c730ddf99562b9.svg";
export { ForwardRef as ReactComponent };